import { SET_PAGE_NUMBER, SET_ROWS_PER_PAGE } from "../utils/constants/redux";

const initialState = {
  pageNumber: 1,
  rowsPerPage: 25,
};

const searchFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PAGE_NUMBER:
      return { ...state, pageNumber: action.payload };

    case SET_ROWS_PER_PAGE:
      return { ...state, rowsPerPage: action.payload };

    default:
      return state;
  }
};

export default searchFilterReducer;
